/**
 * ProtectedRoute Component
 * Wraps admin routes to ensure user is authenticated
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '@/stores/adminAuthStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAdminAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login page, preserving the attempted location
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
